import { render, staticRenderFns } from "./DemandeDavoirForm.vue?vue&type=template&id=bed40606&scoped=true&lang=true"
import script from "./DemandeDavoirForm.vue?vue&type=script&lang=js"
export * from "./DemandeDavoirForm.vue?vue&type=script&lang=js"
import style0 from "./DemandeDavoirForm.vue?vue&type=style&index=0&id=bed40606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed40606",
  null
  
)

export default component.exports